import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Space, Row, Col, DatePicker, Drawer, Radio } from 'antd';
import { UserOutlined } from "@ant-design/icons";
import { isMobile } from 'react-device-detect';
import BaseSelect from '@/components/Elements/BaseSelect';
import { updateCustomerScheduleStatus } from '@/redux/actions/CustomerScheduleActions';
import { getCustomerStatusActive } from "@/redux/actions/CustomerStatusActions";
import { _newLine, isValidDateForm } from '@/utils/helpers';

class CustomerScheduleUpdateStatusForm extends Component {
    constructor() {
        super();
        this.state = {
            require_time: false,
            switch_status: false,
            is_start_time: false,
            hasArrived: false,
            disabledDangtrongca: true,
            disabledDaxong: true
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.currentItem !== this.props.currentItem && nextProps.currentItem) {
            const current = nextProps.currentItem;

            // --- Kiểm tra dữ liệu thực tế trong DB ---
            const hasArrived = !!current?.time_to;
            const hasStartTime = !!current?.start_time;
            const switch_status = current?.name === 'GOILAI';
            const status = current?.status || 'chuaden';

            // --- Xác định yêu cầu hiển thị thời gian ---
            const require_time = switch_status
                ? status === 'dagoi'
                : status === 'dangcho' || status === 'daden';

            const is_start_time = status === 'dangtrongca';

            // --- Điều khiển disable ---
            let disabledDangtrongca = true;
            let disabledDaxong = true;

            if (hasArrived || status === 'daden' || status === 'dangcho') {
                disabledDangtrongca = false; // Cho phép “Đang trong ca”
            }

            if (hasStartTime || status === 'dangtrongca') {
                disabledDaxong = false; // Cho phép “Đã xong”
            }

            // --- Cập nhật state ---
            this.setState({
                require_time,
                is_start_time,
                switch_status,
                hasArrived,
                disabledDangtrongca,
                disabledDaxong,
            });

            console.log('📘 [componentWillReceiveProps] sync state:', {
                status,
                hasArrived,
                hasStartTime,
                switch_status,
                disabledDangtrongca,
                disabledDaxong,
                require_time,
                is_start_time,
            });
        }
    }

    // Khi bấm Cập nhật
    async onchangeStatus(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true });
                try {
                    values.time_to = values.time_to ? values.time_to.format("YYYY-MM-DD HH:mm") : null;
                    values.start_time = values.start_time ? values.start_time.format("YYYY-MM-DD HH:mm") : null;
                    await this.props.updateCustomerScheduleStatus(this.props.currentItem.id, values);
                    this.props.reloadData();
                    this.onCancel();
                } catch (error) {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    onCancel() {
        this.props.form.resetFields();
        this.props.onCancel();
        this.setState({ isLoading: false });
        this.setState({
            isLoading: false,
            require_time: false,
            switch_status: false,
            is_start_time: false,
            hasArrived: false
        });
    }

    changeStatus(value) {
        const { switch_status } = this.state;
        const { currentItem } = this.props;

        // --- Kiểm tra dữ liệu thực tế trong DB ---
        const hasArrived = !!currentItem?.time_to;
        const hasStartTime = !!currentItem?.start_time;

        // --- Xác định yêu cầu hiển thị thời gian ---
        const requireTime = switch_status
            ? value === 'dagoi'
            : value === 'dangcho' || value === 'daden';
        const isStart = value === 'dangtrongca';

        // --- Điều khiển disable ---
        let disabledDangtrongca = true;
        let disabledDaxong = true;

        // Nếu đã có time_to → cho phép “Đang trong ca”
        if (hasArrived) disabledDangtrongca = false;

        // Nếu đã có start_time → cho phép “Đã xong”
        if (hasStartTime) disabledDaxong = false;

        // Nếu người dùng vừa chọn trạng thái “Đang chờ (đã đến)” thì cho phép bước tiếp
        //if (value === 'daden' || value === 'dangcho') disabledDangtrongca = false;

        // Nếu người dùng vừa chọn “Đang trong ca” thì có thể chọn “Đã xong”
        //if (value === 'dangtrongca') disabledDaxong = false;

        // --- Cập nhật state ---
        this.setState({
            require_time: requireTime,
            is_start_time: isStart,
            hasArrived,
            disabledDangtrongca,
            disabledDaxong,
        });

        console.log('changeStatus2:', {
            value,
            hasArrived,
            hasStartTime,
            disabledDangtrongca,
            disabledDaxong,
            requireTime,
            isStart,
        });
    }


    render() {
        var { isLoading, require_time, switch_status, is_start_time, disabledDangtrongca, disabledDaxong } = this.state;
        var { visible, currentItem, consultants, customerStatusActiveList } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer
                visible={visible}
                title="Cập nhật trạng thái lịch hẹn"
                onClose={() => this.onCancel()}
                maskClosable={false}
                width={isMobile ? '100%' : '50%'}
                footer={
                    <div style={{ textAlign: 'right', }}>
                        <Space>
                            <Button key="back" onClick={() => this.onCancel()}>
                                Huỷ
                            </Button>
                            <Button
                                loading={isLoading}
                                key="submit"
                                type="primary"
                                onClick={(e) => this.onchangeStatus(e)}
                            >
                                Cập nhật
                            </Button>
                        </Space>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24} className='mb-3'>
                                <h6><UserOutlined /> Khách hàng: <span className='color-primary'>{currentItem?.customer_name} - {currentItem?.customer_code}</span></h6>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Form.Item label="Trạng thái">
                                    {getFieldDecorator('status', {
                                        rules: [{ required: true, message: 'Vui lòng chọn trạng thái!' }],
                                        initialValue: currentItem ? currentItem.status : (switch_status ? 'chuagoi' : 'chuaden'),
                                    })(
                                        <Radio.Group onChange={e => this.changeStatus(e.target.value)}>
                                            {(switch_status
                                                ? [
                                                    { value: 'chuagoi', label: 'Chưa gọi' },
                                                    { value: 'dagoi', label: 'Đã gọi' },
                                                ]
                                                : [
                                                    { value: 'daden', label: 'Đang chờ (đã đến)' },
                                                    { value: 'dangtrongca', label: 'Đang trong ca', disabled: disabledDangtrongca },
                                                    { value: 'daxong', label: 'Đã xong', disabled: disabledDaxong },
                                                    { value: 'chuaden', label: 'Chưa đến' },
                                                    { value: 'dahuy', label: 'Đã hủy' },
                                                ]
                                            ).map(opt => (
                                                <Radio key={opt.value} value={opt.value} disabled={opt.disabled}>
                                                    {opt.label}
                                                </Radio>
                                            ))}
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                            </Col>
                            {is_start_time && (
                                <Col xs={24} md={24}>
                                    <Form.Item label={`Thời gian bắt đầu`}>
                                        {getFieldDecorator('start_time', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Vui lòng điền!',
                                                },
                                            ],
                                            initialValue: isValidDateForm(currentItem.start_time, true)
                                        })(
                                            <DatePicker
                                                style={{ width: '100%' }}
                                                showTime={{ format: 'HH:mm' }}
                                                format="DD/MM/YYYY HH:mm"
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            )}

                            {
                                require_time ? (
                                    <>
                                        <Col xs={24} md={24}>
                                            <Form.Item label={`Thời điểm ${switch_status ? 'gọi' : 'đến'}`}>
                                                {getFieldDecorator('time_to', {
                                                    rules: [
                                                        {
                                                            required: require_time,
                                                            message: 'Vui lòng điền!',
                                                        },
                                                    ],
                                                    initialValue: isValidDateForm(currentItem.time_to, true)
                                                })(
                                                    <DatePicker
                                                        style={{ width: '100%' }}
                                                        showTime={{ format: 'HH:mm' }}
                                                        format="DD/MM/YYYY HH:mm"
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        {
                                            currentItem && currentItem?.name == 'TUVAN' ? (
                                                <Col xs={24} md={24}>
                                                    <Form.Item label="Nhân viên tư vấn trực tiếp">
                                                        {getFieldDecorator("consultant_direct_staff_ids", {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "Vui lòng chọn!",
                                                                },
                                                            ],
                                                            initialValue: currentItem ? currentItem?.staff_consultant_direct_ids : []
                                                        })(
                                                            <BaseSelect
                                                                options={consultants ?? []}
                                                                optionValue="user_id"
                                                                optionLabel="display_name"
                                                                placeholder="Chọn 1 hoặc nhiều nhân viên tư vấn"
                                                                defaultText="Chọn nhân viên tư vấn"
                                                                showSearch={true}
                                                                mode="multiple"
                                                                className="w-100"
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            ) : null
                                        }
                                    </>
                                ) : null
                            }
                            {/* <Col xs={24} md={24}>
                                <Form.Item label='Trạng thái khách hàng'>
                                    {getFieldDecorator("customer_status_id", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.customer_status_id : null,
                                        normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                    })(
                                        <BaseSelect
                                            options={customerStatusActiveList || []}
                                            optionValue="id"
                                            optionLabel="name"
                                            showSearch
                                            placeholder="Chọn một bản ghi"
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col> */}
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.note) : ""
                                    })(
                                        <Input.TextArea rows={8} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null}
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        users: state.config.users,
        consultants: state.config.consultants,
        customerStatusActiveList: state.CustomerStatusReducer.customerStatusActiveList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateCustomerScheduleStatus: (id, data) => dispatch(updateCustomerScheduleStatus(id, data)),
        getCustomerStatusActive: () => dispatch(getCustomerStatusActive()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerScheduleUpdateStatusForm' })(CustomerScheduleUpdateStatusForm));
